// Übersetzungen: UI-Texte gebündelt, Kapiteltexte werden mit dem Kapitel nachgeladen.
import de from './locales/de.json';

type Dict = { [k: string]: string | Dict };
const dicts: Dict[] = [de as unknown as Dict];
export const missing = new Set<string>();

export function addStrings(d: Dict) {
  dicts.unshift(d);
}

function lookup(d: Dict, key: string): string | undefined {
  let cur: string | Dict | undefined = d;
  for (const part of key.split('.')) {
    if (cur === undefined || typeof cur === 'string') return undefined;
    cur = cur[part];
  }
  return typeof cur === 'string' ? cur : undefined;
}

export function has(key: string): boolean {
  return dicts.some((d) => lookup(d, key) !== undefined);
}

export function t(key: string, vars?: Record<string, string | number>): string {
  for (const d of dicts) {
    const v = lookup(d, key);
    if (v !== undefined) return vars ? v.replace(/\{(\w+)\}/g, (_, k) => String(vars[k] ?? '')) : v;
  }
  missing.add(key);
  return `⟨${key}⟩`;
}
